define('RTC.Cart.View', [
    'RTC.Model',

    'cart_rtc_checkout.tpl',

    'Backbone',

    'jQuery',
    'underscore'
], function RTCCartView(
    RTCModel,

    cartRTCCheckoutTpl,

    Backbone,

    jQuery,
    _
) {
    'use strict';

    return Backbone.View.extend({
        title: _('RTC Cart Summary').translate(),

        template: cartRTCCheckoutTpl,

        events: {
            'click [data-action="rtc-checkout"]': 'goToCheckout'
        },

        initialize: function initialize() {
            this.rtc = new RTCModel();
        },

        goToCheckout: function goToCheckout(e) {
            var $target = jQuery(e.target);

            if (SC.ENVIRONMENT.published.isRtcCheckout !== 'T' && $target.data('success') !== 'T') {
                this.rtc.fetch({
                    type: 'put'
                }).done(function afterFetch(data) {
                    $target.data('success', data.success ? 'T' : 'F');
                    $target.trigger('click');
                });
                e.preventDefault(); e.stopPropagation();
            }
        }
    });
});

